import { deletePaymentLink } from '@api/payment-links';
import { Button, WarningModal } from '@basqet-dashboard/common/components';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { toast } from 'react-toastify';

const DeletePaymentLink = ({ closeModal, linkToDelete }) => {
  const [isLoading, setIsLoading] = useState(false);

  const removePaymentLink = async () => {
    setIsLoading(true);
    try {
      await deletePaymentLink(linkToDelete);
      await toast.success(`Payment link deleted`);
      closeModal();
      setIsLoading(false);
    } catch {
      toast.error('There was an error deleting the payment link');
      setIsLoading(false);
    }
  };

  return (
    <WarningModal header={{ name: 'Delete', cursive: 'Link' }} onModalClose={closeModal}>
      <p className="modal__text">Are you sure you want to delete this link?</p>
      <Button isFull variant="outline" onClick={closeModal}>
        Cancel
      </Button>
      <br />
      <Button isFull variant="primary" onClick={removePaymentLink} isLoading={isLoading}>
        Yes, continue
      </Button>
    </WarningModal>
  );
};

DeletePaymentLink.propTypes = {
  closeModal: PropTypes.func,
  linkToDelete: PropTypes.string
};
export { DeletePaymentLink };
